import { OwcTypography } from '@one/react';
import { useTranslation } from 'core/i18n';
import { RefreshButton } from '../generic-buttons';
import { ContentWithFooterLayout } from '../layouts';
import { EmptyListComponentLayout } from './empty-list.style';

interface EmptyListComponentProps {
  description: string;
}

export const EmptyListComponent: React.FC<EmptyListComponentProps> = props => {
  const { description } = props;

  const { t } = useTranslation('common');

  return (
    <ContentWithFooterLayout footer={<RefreshButton />}>
      <EmptyListComponentLayout>
        <img src="/assets/images/empty-list.svg" alt={t('components.empty-list.alt')} />
        <OwcTypography className="text-center" variant="body1">
          {description}
        </OwcTypography>
      </EmptyListComponentLayout>
    </ContentWithFooterLayout>
  );
};
